import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { TranslateModule } from '@ngx-translate/core';
import { PackageOperationVO } from '@app/api/stock-service/model/packageOperationVO';
import { PackageInventoryItem } from '../../package-operation.config';

@Component({
  selector: 'app-package-operation-history-drawer',
  standalone: true,
  imports: [CommonModule, DrawerModule, TranslateModule],
  templateUrl: './package-operation-history-drawer.component.html',
  styleUrl: './package-operation-history-drawer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageOperationHistoryDrawerComponent {
  @Input({ required: true }) visible = false;
  @Input() packageSku: PackageInventoryItem | null = null;
  @Input() historyItems: PackageOperationVO[] = [];
  @Input() loading = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  close(): void {
    this.visibleChange.emit(false);
  }

  operationTypeLabel(operationType?: string): string {
    return operationType === 'PACK'
      ? 'package_operation.options.pack'
      : operationType === 'UNPACK'
        ? 'package_operation.options.unpack'
        : '-';
  }

  warehouseLabel(operation: PackageOperationVO): string {
    if (operation.warehouseCode) {
      return operation.warehouseName
        ? `${operation.warehouseCode} - ${operation.warehouseName}`
        : operation.warehouseCode;
    }

    return (
      this.packageSku?.warehouses.find((warehouse) => warehouse.id === operation.warehouseId)
        ?.code ?? '-'
    );
  }
}
